import React, { createCondiv, useCondiv, useRef, useState, useEffect, useReducer } from 'react';


const HORIZONTAL_SCALE = (props) => {
    const { dashWidth, onAnswer, questionIndex, question } = props;
    const [selected, setSelected] = useState(null);
    const [ min, setMin ] = useState('');
    const [ max, setMax ] = useState('');

    useEffect(() => {
        const parsed = JSON.parse(question.options[0]);
        setMin(parsed.minimum);
        setMax(parsed.maximum);
    }, [question])

    const onClick = (value) => {
        setSelected(value);
        if (onAnswer) {
            onAnswer(value, questionIndex);
        }
    }

    const scale = [
        {
            value: '0',
            color: '#25852e'
        },
        {
            value: '1',
            color: '#38a740'
        },
        {
            value: '2',
            color: '#8abb37'
        },
        {
            value: '3',
            color: '#9bbf32'
        },
        {
            value: '4',
            color: '#f5d705'
        },
        {
            value: '5',
            color: '#f5d61d'
        },
        {
            value: '6',
            color: '#f6d800'
        },
        {
            value: '7',
            color: '#e9761c'
        },
        {
            value: '8',
            color: '#d83821'
        },
        {
            value: '9',
            color: '#b5181b'
        },
        {
            value: '10'
        },
    ]

    return (
        <div>
            <div className="scale-container">
                {scale.map((item, index) => (
                    <div key={`horizontal-unit-${index}`} className="d-flex">
                        <div onClick={() => onClick(item.value)} className={selected === item.value ? 'scale-selected' : 'scale-unit'}>{item.value}</div>
                        {item.color && (
                            <div className="scale-dash" style={{ width: dashWidth, backgroundColor: item.color }} />
                        )}
                    </div>
                ))}
            </div>
            <div className="d-flex justify-content-between mb-4">
                <div>{min}</div>
                <div>{max}</div>
            </div>

            {selected ? (
                <div className="text-center">
                    <h4>{selected}</h4>
                    <h6>SELECTED</h6>
                </div>
            ) : (
                    <h6 className="text-center">Select a number to begin</h6>
                )}
        </div>
    )
}

export default HORIZONTAL_SCALE;